/**
 * @param obj 原始数据对象
 * @param formData FormData 实例
 * @param parentKey 父级 key
 * @param flatKeyList 指定哪些 key 需要平铺上传（不带 [index] 下标）
 */
export const objectToFormData = (
  obj,
  flatKeyList, // 传入需要平铺的 key，例如 ['declaration_receipt']
  formData = new FormData(),
  parentKey = '',
) => {
  Object.keys(obj).forEach(key => {
    let value = obj[key];
    // 基础 Key 名
    const formKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value === null || value === undefined) return;

    // 1. 数组特殊处理：检查是否在平铺白名单中
    if (Array.isArray(value)) {
      const isFlatKey = flatKeyList.includes(key);
      
      value.forEach((element, index) => {
        // 如果是平铺 Key，直接使用 formKey；否则使用带下标的 arrayKey
        const finalKey = isFlatKey ? formKey : `${formKey}[${index}]`;
        
        // 提取原始文件流
        const actualElement = (element && typeof element === 'object') 
          ? (element.raw || element.originFileObj || element) 
          : element;

        if (actualElement instanceof Blob) {
          // 如果是文件，追加二进制
          formData.append(finalKey, actualElement, actualElement.name || 'file');
        } else if (typeof actualElement === 'object' && actualElement !== null && !isFlatKey) {
          // 如果是对象且不需要平铺，递归处理
          objectToFormData(actualElement, flatKeyList, formData, finalKey);
        } else {
          // 字符串 URL 或基本类型，直接追加
          formData.append(finalKey, actualElement);
        }
      });
      return;
    }

    // 2. 单个文件对象提取
    if (typeof value === 'object' && !(value instanceof Blob)) {
      const rawFile = value.raw || value.originFileObj;
      if (rawFile instanceof Blob) value = rawFile;
    }

    // 3. 处理单体值（文件或基本类型）
    if (value instanceof Blob) {
      formData.append(formKey, value, value instanceof File ? value.name : 'blob');
    } else if (typeof value === 'object') {
      // 普通对象递归
      objectToFormData(value, flatKeyList, formData, formKey);
    } else {
      // 基本类型
      formData.append(formKey, value);
    }
  });

  return formData;
};